import { DelegateV2, V2Delegation } from '@delegatexyz/sdk';
import { http } from 'viem';

import {
  baseDelegatedContractAddresses,
  ethereumDelegatedContractAddresses,
} from './delegated-contract-mapping';

const ethereumConfig = {
  urlName:
    process.env.NEXT_PUBLIC_APP_ENV === 'production'
      ? 'eth-mainnet'
      : 'eth-sepolia',
};

const baseConfig = {
  urlName:
    process.env.NEXT_PUBLIC_APP_ENV === 'production'
      ? 'base-mainnet'
      : 'base-sepolia',
};

const ETH_RPC_URL = `https://${ethereumConfig.urlName}.g.alchemy.com/v2/${
  process.env.NEXT_PUBLIC_ALCHEMY_API_KEY as string
}`;

const BASE_RPC_URL = `https://${baseConfig.urlName}.g.alchemy.com/v2/${
  process.env.NEXT_PUBLIC_ALCHEMY_API_KEY as string
}`;

export const getDelegatorsFromAddress = async (
  address: string,
): Promise<V2Delegation[]> => {
  try {
    const delegatorsAddresses: V2Delegation[] = [];
    const delegatorsContractAddresses: V2Delegation[] = [];

    const ethereumDelegatev2 = new DelegateV2({
      userTransport: http(ETH_RPC_URL),
    });
    const baseDelegatev2 = new DelegateV2({
      userTransport: http(BASE_RPC_URL),
    });

    const datav2: V2Delegation[] = [];
    // For` V2
    const ethdatav2 = await ethereumDelegatev2.getIncomingDelegations(
      address as `0x${string}`,
    );

    const basedatav2 = await baseDelegatev2.getIncomingDelegations(
      address as `0x${string}`,
    );

    datav2.push(...ethdatav2, ...basedatav2);

    for (const V2delegation of datav2) {
      console.log('V2delegation checking for ', V2delegation);
      if (V2delegation.type === 'ALL') {
        delegatorsAddresses.push(V2delegation);
      } else {
        const isValidContract =
          ethereumDelegatedContractAddresses.includes(
            V2delegation.contract?.toLowerCase(),
          ) ||
          baseDelegatedContractAddresses.includes(
            V2delegation.contract?.toLowerCase(),
          );

        if (!isValidContract) {
          console.error('Invalid contract', V2delegation.contract);
          continue;
        }

        delegatorsContractAddresses.push(V2delegation);
      }
    }

    return [
      ...new Set(delegatorsAddresses),
      ...new Set(delegatorsContractAddresses),
    ];
  } catch (e) {
    console.log(e);
  }

  return [];
};
